var installedModules = {};
var moduleToHandlerMapping = {
	85683: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	30299: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.4.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	17015: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	61425: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	63999: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.4.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	28589: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	18717: {
		getter: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	4710: {
		getter: () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	98179: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=14.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	31698: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	90434: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	97049: {
		getter: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=14.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	96230: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	10888: {
		getter: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	57148: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	92673: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	3388: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.5.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	19736: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.5.3 || ^7.5.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	19869: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	21451: {
		getter: () => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 37989))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.3.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@auth0/auth0-angular",
	},
	38984: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/domain-logic */ 73467))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/domain-logic",
	},
	7011: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	49499: {
		getter: () => (() => (__webpack_require__(/*! rxjs */ 80845))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	47339: {
		getter: () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	9965: {
		getter: () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	4697: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/models-environment */ 50831))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/models-environment",
	},
	26464: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util */ 57863))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util",
	},
	1887: {
		getter: () => (() => (__webpack_require__(/*! @ngrx/store */ 81383))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/store",
	},
	24131: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-state-store */ 72495))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-state-store",
	},
	62597: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-events */ 48815))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-events",
	},
	55152: {
		getter: () => (() => (__webpack_require__(/*! @auth0/angular-jwt */ 92389))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~5.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@auth0/angular-jwt",
	},
	186: {
		getter: () => (() => (__webpack_require__(/*! @angular/core */ 37580))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0 || ^21.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	87984: {
		getter: () => (() => (__webpack_require__(/*! @angular/common */ 60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0 || ^21.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	99914: {
		getter: () => (() => (__webpack_require__(/*! @ngrx/store */ 81383))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/store",
	},
	6263: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-form-controls */ 59175))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-form-controls",
	},
	52865: {
		getter: () => (() => (__webpack_require__(/*! @angular/forms */ 34456))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	56705: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui */ 21919))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui",
	},
	7375: {
		getter: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	67487: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-badge */ 39319))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-badge",
	},
	81239: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-icon */ 49175))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-icon",
	},
	36406: {
		getter: () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^20.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	38496: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-button */ 29321))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-button",
	},
	59516: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-loading */ 67935))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-loading",
	},
	11831: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-tooltip */ 74231))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-tooltip",
	},
	67183: {
		getter: () => (() => (__webpack_require__(/*! @popperjs/core */ 41280))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.11.8",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@popperjs/core",
	},
	72458: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-tooltip-trigger */ 93715))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-tooltip-trigger",
	},
	63858: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-details */ 89487))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-details",
	},
	63159: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-context-menu */ 47347))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-context-menu",
	},
	82048: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-dialog */ 94869))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-dialog",
	},
	95122: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-alert */ 68824))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-alert",
	},
	94211: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-logging */ 62943))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-logging",
	},
	43999: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-toast */ 57103))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-toast",
	},
	2851: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-tab */ 51215))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-tab",
	},
	40307: {
		getter: () => (() => (__webpack_require__(/*! @angular/forms */ 34456))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	22387: {
		getter: () => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	52147: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/domain-logic */ 35492))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/domain-logic",
	},
	88231: {
		getter: () => (() => (__webpack_require__(/*! @popperjs/core */ 41280))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.11.8",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@popperjs/core",
	},
	15644: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-list */ 67909))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-list",
	},
	39828: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-search-control */ 59689))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-search-control",
	},
	93534: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-search */ 89605))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-search",
	},
	27153: {
		getter: () => (() => (__webpack_require__(/*! @angular/router */ 95072))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "20.3.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	56691: {
		getter: () => (() => (__webpack_require__(/*! jszip */ 45834))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.10.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "jszip",
	},
	8573: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-stepper */ 32575))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-stepper",
	},
	66372: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-table */ 8191))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-table",
	},
	75608: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-pagination */ 84085))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-pagination",
	},
	43746: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-panel */ 19591))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-panel",
	},
	70604: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/util-integration */ 74779))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/util-integration",
	},
	59078: {
		getter: () => (() => (__webpack_require__(/*! @microsoft/applicationinsights-web */ 75205))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/applicationinsights-web",
	},
	38701: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/feature-load-remote */ 31935))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/feature-load-remote",
	},
	89304: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-off-canvas */ 46137))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-off-canvas",
	},
	38698: {
		getter: () => (() => (__webpack_require__(/*! @snelstart/ui-card */ 86881))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart/ui-card",
	},
	78669: {
		getter: () => (() => (__webpack_require__(/*! @snelstart-ventures/fiscaal/feature-tax-allowance-details */ 1101))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@snelstart-ventures/fiscaal/feature-tax-allowance-details",
	}
};
var initialConsumes = [85683,30299,17015,61425,63999,28589,18717,4710,98179,31698,90434,97049,96230,10888,57148,92673,3388,19736,19869,21451,38984,7011,49499,47339,9965,4697,26464,1887,24131,62597,55152,186,87984,99914,6263,52865,56705,7375,67487,81239,36406,38496,59516,11831,67183,72458,63858,63159,82048,95122,94211,43999,2851,40307,22387,52147,88231,15644,39828,93534,27153,56691,8573,66372,75608,43746,70604,59078,38701,89304,38698,78669];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"polyfills": [
		85683,
		30299,
		17015,
		61425,
		63999,
		28589,
		18717,
		4710,
		98179,
		31698,
		90434,
		97049,
		96230,
		10888,
		57148,
		92673,
		3388,
		19736,
		19869,
		21451,
		38984,
		7011,
		49499,
		47339,
		9965,
		4697,
		26464,
		1887,
		24131,
		62597,
		55152,
		186,
		87984,
		99914,
		6263,
		52865,
		56705,
		7375,
		67487,
		81239,
		36406,
		38496,
		59516,
		11831,
		67183,
		72458,
		63858,
		63159,
		82048,
		95122,
		94211,
		43999,
		2851,
		40307,
		22387,
		52147,
		88231,
		15644,
		39828,
		93534,
		27153,
		56691,
		8573,
		66372,
		75608,
		43746,
		70604,
		59078,
		38701,
		89304,
		38698,
		78669
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}